import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    // List treasure boxes
    listTreasureBoxesLoading: false,
    listTreasureBoxesSuccess: false,
    listTreasureBoxesFail: false,
    listTreasureBoxesData: [],
    listTreasureBoxesErrorMessage: null,

    // Get treasure box detail
    getTreasureBoxDetailLoading: false,
    getTreasureBoxDetailSuccess: false,
    getTreasureBoxDetailFail: false,
    getTreasureBoxDetailData: null,
    getTreasureBoxDetailErrorMessage: null,

    // Play treasure box
    playTreasureBoxLoading: false,
    playTreasureBoxSuccess: false,
    playTreasureBoxFail: false,
    playTreasureBoxData: null,
    playTreasureBoxErrorMessage: null,

    // Get wallet
    getWalletLoading: false,
    getWalletSuccess: false,
    getWalletFail: false,
    getWalletData: null,
    getWalletErrorMessage: null,

    // Get my plays
    getMyPlaysLoading: false,
    getMyPlaysSuccess: false,
    getMyPlaysFail: false,
    getMyPlaysData: [],
    getMyPlaysPage: 1,
    getMyPlaysPageCount: 0,
    getMyPlaysTotalCount: 0,
    getMyPlaysErrorMessage: null,

    // Update shipping
    confirmReceiveLoading: false,
    confirmReceiveSuccess: false,
    confirmReceiveErrorMessage: null,
    updateShippingLoading: false,
    updateShippingSuccess: false,
    updateShippingFail: false,
    updateShippingErrorMessage: null,
}

export const treasureBoxSlice = createSlice({
    name: "treasureBox",
    initialState,
    reducers: {
        // List Treasure Boxes Actions
        listTreasureBoxesRequest: (state) => {
            state.listTreasureBoxesLoading = true
            state.listTreasureBoxesSuccess = false
            state.listTreasureBoxesFail = false
            state.listTreasureBoxesErrorMessage = null
        },
        listTreasureBoxesSuccessAction: (state, action) => {
            state.listTreasureBoxesLoading = false
            state.listTreasureBoxesSuccess = true
            state.listTreasureBoxesFail = false
            state.listTreasureBoxesData = action.payload
            state.listTreasureBoxesErrorMessage = null
        },
        listTreasureBoxesFailAction: (state, action) => {
            state.listTreasureBoxesLoading = false
            state.listTreasureBoxesSuccess = false
            state.listTreasureBoxesFail = true
            state.listTreasureBoxesErrorMessage = action.payload
        },

        // Get Treasure Box Detail Actions
        getTreasureBoxDetailRequest: (state) => {
            state.getTreasureBoxDetailLoading = true
            state.getTreasureBoxDetailSuccess = false
            state.getTreasureBoxDetailFail = false
            state.getTreasureBoxDetailErrorMessage = null
        },
        getTreasureBoxDetailSuccessAction: (state, action) => {
            state.getTreasureBoxDetailLoading = false
            state.getTreasureBoxDetailSuccess = true
            state.getTreasureBoxDetailFail = false
            state.getTreasureBoxDetailData = action.payload
            state.getTreasureBoxDetailErrorMessage = null
        },
        getTreasureBoxDetailFailAction: (state, action) => {
            state.getTreasureBoxDetailLoading = false
            state.getTreasureBoxDetailSuccess = false
            state.getTreasureBoxDetailFail = true
            state.getTreasureBoxDetailErrorMessage = action.payload
        },

        // Play Treasure Box Actions
        playTreasureBoxRequest: (state) => {
            state.playTreasureBoxLoading = true
            state.playTreasureBoxSuccess = false
            state.playTreasureBoxFail = false
            state.playTreasureBoxErrorMessage = null
        },
        playTreasureBoxSuccessAction: (state, action) => {
            state.playTreasureBoxLoading = false
            state.playTreasureBoxSuccess = true
            state.playTreasureBoxFail = false
            state.playTreasureBoxData = action.payload
            state.playTreasureBoxErrorMessage = null
        },
        playTreasureBoxFailAction: (state, action) => {
            state.playTreasureBoxLoading = false
            state.playTreasureBoxSuccess = false
            state.playTreasureBoxFail = true
            state.playTreasureBoxErrorMessage = action.payload
        },
        playTreasureBoxReset: (state) => {
            state.playTreasureBoxLoading = false
            state.playTreasureBoxSuccess = false
            state.playTreasureBoxFail = false
            state.playTreasureBoxData = null
            state.playTreasureBoxErrorMessage = null
        },

        // Get Wallet Actions
        getWalletRequest: (state) => {
            state.getWalletLoading = true
            state.getWalletSuccess = false
            state.getWalletFail = false
            state.getWalletErrorMessage = null
        },
        getWalletSuccessAction: (state, action) => {
            state.getWalletLoading = false
            state.getWalletSuccess = true
            state.getWalletFail = false
            state.getWalletData = action.payload
            state.getWalletErrorMessage = null
        },
        getWalletFailAction: (state, action) => {
            state.getWalletLoading = false
            state.getWalletSuccess = false
            state.getWalletFail = true
            state.getWalletErrorMessage = action.payload
        },

        // Get My Plays Actions
        getMyPlaysRequest: (state) => {
            state.getMyPlaysLoading = true
            state.getMyPlaysSuccess = false
            state.getMyPlaysFail = false
            state.getMyPlaysErrorMessage = null
        },
        getMyPlaysSuccessAction: (state, action) => {
            state.getMyPlaysLoading = false
            state.getMyPlaysSuccess = true
            state.getMyPlaysFail = false
            state.getMyPlaysData = action.payload.data || action.payload
            state.getMyPlaysPage = action.payload.current_page || 1
            state.getMyPlaysPageCount = action.payload.page_count || 0
            state.getMyPlaysTotalCount = action.payload.total_row || 0
            state.getMyPlaysErrorMessage = null
        },
        getMyPlaysFailAction: (state, action) => {
            state.getMyPlaysLoading = false
            state.getMyPlaysSuccess = false
            state.getMyPlaysFail = true
            state.getMyPlaysErrorMessage = action.payload
        },

        // Update Shipping Actions
        updateShippingRequest: (state) => {
            state.updateShippingLoading = true
            state.updateShippingSuccess = false
            state.updateShippingFail = false
            state.updateShippingErrorMessage = null
        },
        updateShippingSuccessAction: (state) => {
            state.updateShippingLoading = false
            state.updateShippingSuccess = true
            state.updateShippingFail = false
        },
        updateShippingFailAction: (state, action) => {
            state.updateShippingLoading = false
            state.updateShippingSuccess = false
            state.updateShippingFail = true
            state.updateShippingErrorMessage = action.payload
        },
        resetUpdateShippingSuccess: (state) => {
            state.updateShippingSuccess = false
        },
        // Confirm receipt of a won physical prize
        confirmReceiveRequest: (state) => {
            state.confirmReceiveLoading = true
            state.confirmReceiveSuccess = false
            state.confirmReceiveErrorMessage = null
        },
        confirmReceiveSuccessAction: (state) => {
            state.confirmReceiveLoading = false
            state.confirmReceiveSuccess = true
        },
        confirmReceiveFailAction: (state, action) => {
            state.confirmReceiveLoading = false
            state.confirmReceiveErrorMessage = action.payload
        },
    },
})

export const {
    listTreasureBoxesRequest,
    listTreasureBoxesSuccessAction,
    listTreasureBoxesFailAction,
    getTreasureBoxDetailRequest,
    getTreasureBoxDetailSuccessAction,
    getTreasureBoxDetailFailAction,
    playTreasureBoxRequest,
    playTreasureBoxSuccessAction,
    playTreasureBoxFailAction,
    playTreasureBoxReset,
    getWalletRequest,
    getWalletSuccessAction,
    getWalletFailAction,
    getMyPlaysRequest,
    getMyPlaysSuccessAction,
    getMyPlaysFailAction,
    updateShippingRequest,
    updateShippingSuccessAction,
    updateShippingFailAction,
    resetUpdateShippingSuccess,
    confirmReceiveRequest,
    confirmReceiveSuccessAction,
    confirmReceiveFailAction,
} = treasureBoxSlice.actions

// Selectors
export const getListTreasureBoxes = (state) => state.treasureBox.listTreasureBoxesData
export const getTreasureBoxDetail = (state) => state.treasureBox.getTreasureBoxDetailData
export const getPlayTreasureBox = (state) => state.treasureBox.playTreasureBoxData
export const getWallet = (state) => state.treasureBox.getWalletData
export const getMyPlays = (state) => state.treasureBox.getMyPlaysData
export const getMyPlaysPage = (state) => state.treasureBox.getMyPlaysPage
export const getMyPlaysPageCount = (state) => state.treasureBox.getMyPlaysPageCount
export const getMyPlaysTotalCount = (state) => state.treasureBox.getMyPlaysTotalCount
export const getMyPlaysLoading = (state) => state.treasureBox.getMyPlaysLoading
export const getUpdateShippingLoading = (state) => state.treasureBox.updateShippingLoading
export const getUpdateShippingSuccess = (state) => state.treasureBox.updateShippingSuccess
export const getUpdateShippingError = (state) => state.treasureBox.updateShippingErrorMessage

// Thunks
export const doListTreasureBoxes = (page = 1, size = 10) => async (dispatch) => {
    try {
        dispatch(listTreasureBoxesRequest())
        const response = await axios.get(`/api/customer/treasure-box`, {
            params: { page, size },
        })
        dispatch(listTreasureBoxesSuccessAction(response.data.data))
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(listTreasureBoxesFailAction(errorMessage))
    }
}

export const doGetTreasureBoxDetail = (treasureBoxId) => async (dispatch) => {
    try {
        dispatch(getTreasureBoxDetailRequest());
        const response = await axios.get(`/api/customer/treasure-box/${treasureBoxId}`);
        
        dispatch(getTreasureBoxDetailSuccessAction(response.data.data));
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(getTreasureBoxDetailFailAction(errorMessage))
    }
}

export const doPlayTreasureBox = (treasureBoxId, shippingData = {}) => async (dispatch) => {
    try {
        dispatch(playTreasureBoxRequest())
        const response = await axios.post(
            `/api/customer/treasure-box/${treasureBoxId}/play`,
            shippingData
        )
        dispatch(playTreasureBoxSuccessAction(response.data.data))
        return response.data.data
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(playTreasureBoxFailAction(errorMessage))
        throw error
    }
}

export const doGetWallet = () => async (dispatch) => {
    try {
        dispatch(getWalletRequest())
        const response = await axios.get(`/api/customer/treasure-box/wallet`)
        dispatch(getWalletSuccessAction(response.data.data))
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(getWalletFailAction(errorMessage))
    }
}

export const doGetMyPlays = (page = 1, size = 10) => async (dispatch) => {
    try {
        dispatch(getMyPlaysRequest())
        const response = await axios.get(`/api/customer/treasure-box/my-plays`, {
            params: { page, size }
        })
        dispatch(getMyPlaysSuccessAction(response.data))
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(getMyPlaysFailAction(errorMessage))
    }
}

export const doUpdatePlayShipping = (playId, shippingData) => async (dispatch) => {
    try {
        dispatch(updateShippingRequest())
        const response = await axios.put(
            `/api/customer/treasure-box-plays/${playId}/shipping`,
            shippingData
        )
        dispatch(updateShippingSuccessAction())
        return response.data
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(updateShippingFailAction(errorMessage))
        throw error
    }
}

export default treasureBoxSlice.reducer
// Customer confirms a delivered prize arrived. The backend stamps received_at;
// there is no 'received' value in the fulfillment_status enum, so that stamp is
// what marks the prize as received.
export const doConfirmPrizeReceive = (playId) => async (dispatch) => {
    try {
        dispatch(confirmReceiveRequest())
        await axios.put(`/api/customer/treasure-box-plays/${playId}/confirm-receive`)
        dispatch(confirmReceiveSuccessAction())
        // re-read so the timeline and status pill reflect the new stamp
        dispatch(doGetMyPlays(1, 200))
    } catch (error) {
        const errorMessage = error.response?.data?.errorMessage || error.message
        dispatch(confirmReceiveFailAction(errorMessage))
    }
}

export const getConfirmReceiveLoading = (s) => s.treasureBox.confirmReceiveLoading
export const getConfirmReceiveError = (s) => s.treasureBox.confirmReceiveErrorMessage
